module.exports = __webpack_public_path__ + "media/slider/Subscription-2-IND-131594af.jpg";